import { WeissmanKeyValueDisplayPipe } from '../../../../UI-Lib/Pipes';
import { ExtendedModelBase } from '../../../Models/extendedModelBase';

export class ExtendedSiteModel extends ExtendedModelBase<Core.SiteModel> {
    constructor(model: Core.SiteModel, keyValueDisplayPipe: WeissmanKeyValueDisplayPipe) {
        super(model);
        this._keyValueDisplayPipe = keyValueDisplayPipe;
        this._displayName = this._keyValueDisplayPipe.transform(this.model, this.model.property, this.model.name);
    }

    private readonly _keyValueDisplayPipe: WeissmanKeyValueDisplayPipe;
    private _displayName: string;

    set displayName(value: string) {
        this._displayName = value;
    }

    get displayName(): string {
        return this._displayName;
    }
}
